import { render, staticRenderFns } from "./ViewSalesOrder.vue?vue&type=template&id=06f7c1bb"
import script from "./ViewSalesOrder.vue?vue&type=script&lang=js"
export * from "./ViewSalesOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewSalesOrder.vue?vue&type=style&index=0&id=06f7c1bb&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f7c1bb')) {
      api.createRecord('06f7c1bb', component.options)
    } else {
      api.reload('06f7c1bb', component.options)
    }
    module.hot.accept("./ViewSalesOrder.vue?vue&type=template&id=06f7c1bb", function () {
      api.rerender('06f7c1bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ViewSalesOrder.vue"
export default component.exports